module.exports = __webpack_public_path__ + "static/media/pin-icon--white.882ff80a.svg";